import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomerListKeptColumnsValue } from '~/utils/customerListMatchingRules';

import { FieldLabel } from '../visitiqCatalog.styles';
import { KeptColumnsList, Muted } from './CustomFieldsField.styles';
import KeptColumnLine from './KeptColumnLine';

interface KeptColumnsDisplayProps {
  label?: string;
  value: CustomerListKeptColumnsValue;
}

/** The submitted kept columns, read-only, as the confirmation card shows them: one line per column. */
const KeptColumnsDisplay = ({ label, value }: KeptColumnsDisplayProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      {label && <FieldLabel>{label}</FieldLabel>}
      <KeptColumnsList>
        {value.fields.length === 0 && <Muted>{t('aiInsights.a2ui.customFields.noneKept')}</Muted>}
        {value.fields.map(([index, columnName, savedName, fieldType]) => (
          <KeptColumnLine key={index} columnName={columnName} savedName={savedName} fieldType={fieldType} />
        ))}
      </KeptColumnsList>
    </div>
  );
};

export default KeptColumnsDisplay;
